import { CatalogPage } from '../../components/ui/CatalogPage'

export function RecipesPage() {
  return <CatalogPage title="Recipes" />
}
